export default __webpack_public_path__ + "static/media/sports2_hl.4e46dc19.png";